import { useSnackbar } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { fetchOrganicMonadesParametrics, PUBLIC_fetchTomeasParametrics } from '../../../../lib/fetchers';
import FormNewRequest from '../FormNewFormRequest';
function SmartNewFormRequest() {
  const [organicUnits, setOrganicUnits] = React.useState<{ label: string, value: string }[]>([]);
  const [tomeas, setTomeas] = React.useState<{ label: string, value: string }[]>([]);
  const [glossa, setGlossa] = React.useState<{ label: string, value: string }[]>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const selectLanguage = [
    { label: 'Ελληνικά (EL)', value: 'el' },
    { label: 'Αγγλικά (EN)', value: 'en' }
  ];

  const doFetch = async () => {

    try {

      const [_organicUnits, _tomeas] = await Promise.all([
        fetchOrganicMonadesParametrics(),
        PUBLIC_fetchTomeasParametrics(),
      ]);
      setOrganicUnits(_organicUnits);
      setTomeas(_tomeas);
      setIsLoading(false);
      setGlossa(selectLanguage);
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('Παρουσιάστηκε κάποιο σφάλμα'), { variant: 'error' });

    }
  };

  React.useEffect(() => {
    doFetch();

  }, []);

  return (<>

    <FormNewRequest
      isLoading={isLoading}
      organicUnits={organicUnits}
      tomeas={tomeas}
      glossa={glossa}
    />
  </>);
}

export default SmartNewFormRequest;